import { ErrorMessageEnum, InputError, InputErrorActionType } from "./types";

export const initialInputErrors = {
  strategicErrors: ["", "", "", ""] as InputError[],
  majorErrors: ["", "", "", ""] as InputError[],
};

export const inputErrorsReducer = (
  state: { strategicErrors: InputError[]; majorErrors: InputError[] },
  action: InputErrorActionType,
) => {
  switch (action.type) {
    case ErrorMessageEnum.STRATEGIC:
      return {
        ...state,
        strategicErrors: state.strategicErrors.map((error, index) => {
          if (index === action.payload.index) {
            return action.payload.message;
          } else {
            return error;
          }
        }),
      };
    case ErrorMessageEnum.MAJOR:
      return {
        ...state,
        majorErrors: state.majorErrors.map((error, index) => {
          if (index === action.payload.index) {
            return action.payload.message;
          } else {
            return error;
          }
        }),
      };
    default:
      return state;
  }
};
